import { Component, OnChanges, SimpleChanges, Input, EventEmitter, Output, Injector, OnInit } from '@angular/core';
import { UnitSystem } from '../../details/UnitSystem';
import { HomeComponent } from '../home/home.component';
import { FormService } from '../../service/FormService';
import { DataToSaveService } from '../../service/data-to-save.service';
import { ImportService } from '../../service/import.service';
import { TrackingService } from '../../service/tracking.service';
import { Router, NavigationStart } from '@angular/router';

enum RecommendationName {
  'O-ring recommendation',
  'Groove recommendation',
  'Design Validation'
}


@Component({
  selector: 'app-design-validation',
  templateUrl: './design-validation.component.html',
  styleUrls: ['./design-validation.component.css'],
  providers: [FormService, ]
})

export class DesignValidationComponent implements OnChanges, OnInit {

  private grooveData: object;
  private oringData: object;
  private dataToCalculate;
  private decimalCount = 2;
  public volumeFillMin;
  public volumeFillNom;
  public volumeFillMax;
  private hiddenColdVolumeFillMin: number;
  private hiddenColdVolumeFillNom: number;
  private hiddenColdVolumeFillMax: number;
  private hiddenHotVolumeFillMin: number;
  private hiddenHotVolumeFillNom: number;
  private hiddenHotVolumeFillMax: number;

  //remove
  private hiddenHotAreaFillMin: number;
  private hiddenHotAreaFillNom: number;
  private hiddenHotAreaFillMax: number
  //

  public operatingSqueezeMin;
  public operatingSqueezeNom;
  public operatingSqueezeMax;
  private hiddenColdOperatingSqueezeMin: number;
  private hiddenColdOperatingSqueezeNom: number;
  private hiddenColdOperatingSqueezeMax: number;
  private hiddenHotOperatingSqueezeMin: number;
  private hiddenHotOperatingSqueezeNom: number;
  private hiddenHotOperatingSqueezeMax: number;


  public stretchMin;
  public stretchNom;
  public stretchMax;
  private hiddenStretchMin: number;
  private hiddenStretchNom: number;
  private hiddenStretchMax: number;
  public squeezeMin;
  public squeezeNom;
  public squeezeMax;
  private hiddenSqueezeMin: number;
  private hiddenSqueezeNom: number;
  private hiddenSqueezeMax: number;
  private coldTemp = 21;
  parentComponent;

  @Input() calculationData;
  @Input() generalData;
  @Output() calculateEventEmitter = new EventEmitter();

  constructor(private inj: Injector, private formService: FormService, private importService: ImportService,
              private dataToSaveService: DataToSaveService, private trackingService: TrackingService, private router: Router) {
    this.parentComponent = this.inj.get(HomeComponent);
  }

  ngOnInit() {
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(() => {
        if (this.router.url === '/home' ) {
          this.dataToSaveService.setCalculatedData(this.returnDataAsObject());
          this.dataToSaveService.setActiveSections(this.parentComponent.recommendations);
        }
    });
    this.getSavedData();
    this.importService.getImportEmitter().subscribe((importResults) => {
      let recommendationType = '';
      if(importResults[10]) {
        recommendationType = importResults[10][1]
      }
      this.getImportedData(importResults[5], recommendationType);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.generalData.currentValue) {
      const getDataType = () => {
        return Boolean(changes.generalData.currentValue.summaryData) ? changes.generalData.currentValue.summaryData :
          changes.generalData.currentValue.calculationData;
      };

      const dataToCalculate = getDataType();
      this.dataToCalculate = dataToCalculate;
      const grooveData = dataToCalculate.grooveData;
      if(this.parentComponent.customOringData) {
        this.oringData = this.parentComponent.customOringData;
      }else {
        this.oringData = dataToCalculate.oringData; //TODO old
      }
      const getGlandAreaByGrooveType = () => {

        // =(L-L tol.)*((W-W tol.)+(L-L tol.)/tan(θ))+2(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360))+S*(w-w Tol.+(2*R2*(1/tan(θ/2)-1))
        const glandAreaMin: number = (+grooveData.glandDepth - +grooveData.glandDepthTol) * ((+grooveData.glandOpening -
                            +grooveData.glandOpeningTol) + (+grooveData.glandDepth - +grooveData.glandDepthTol) /
                            this.calculateTangent(grooveData.angle)) + 2 * (Math.pow(+grooveData.topRadius, 2) -
                            Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(+grooveData.angle / 2) -
                            Math.PI * (180 - +grooveData.angle) / 360) +
                            +grooveData.gap * (+grooveData.glandOpening - +grooveData.glandOpeningTol + (2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        // =L*(W+L/tan(θ))+2(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360))+S*(w+(2*R2*(1/tan(θ/2)-1))
        const glandAreaNom: number =  +grooveData.glandDepth * (+grooveData.glandOpening + +grooveData.glandDepth /
                            this.calculateTangent(grooveData.angle)) + 2 * (Math.pow(+grooveData.topRadius, 2) -
                            Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(grooveData.angle / 2) -
                            Math.PI * (180 - grooveData.angle) / 360) +
                            +grooveData.gap * (+grooveData.glandOpening + (2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        // =(L+L tol.)*((W+W tol.)+(L+L tol.)/tan(θ))+2(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360))+S*(w+w Tol.+(2*R2*(1/tan(θ/2)-1))
        const glandAreaMax: number = (+grooveData.glandDepth + +grooveData.glandDepthTol) * ((+grooveData.glandOpening +
                            +grooveData.glandOpeningTol) + (+grooveData.glandDepth + +grooveData.glandDepthTol) /
                            this.calculateTangent(+grooveData.angle)) + 2 * (Math.pow(+grooveData.topRadius, 2) -
                            Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(+grooveData.angle / 2) -
                            Math.PI * (180 - grooveData.angle) / 360) +
                            +grooveData.gap * (+grooveData.glandOpening + +grooveData.glandOpeningTol + (2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        // =L/2*(2*W+L/tan(θ))+(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360)+(R2^2-R1^2)*(1-pi/4)+S*(W+R2*(1/tan(θ/2)-1)))
        const glandAreaNomHalf: number =  +grooveData.glandDepth  / 2 * (2 * +grooveData.glandOpening + +grooveData.glandDepth /
                                this.calculateTangent(grooveData.angle)) +  (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(+grooveData.angle / 2) -
                                Math.PI * (180 - grooveData.angle) / 360) + (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 - (Math.PI / 4)) +
                                +grooveData.gap * (+grooveData.glandOpening + (dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        // =(L-L tol)/2*(2*(W-W tol)+(L-L tol)/tan(θ))+(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360)+(R2^2-R1^2)*(1-pi/4)+S*(W-W Tol.+R2*(1/tan(θ/2)-1)))
        const glandAreaMinHalf: number = (+grooveData.glandDepth - +grooveData.glandDepthTol)  / 2 * (2 * (+grooveData.glandOpening -
                                +grooveData.glandOpeningTol) + (+grooveData.glandDepth - +grooveData.glandDepthTol) /
                                this.calculateTangent(grooveData.angle)) +  (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(grooveData.angle / 2) -
                                Math.PI * (180 - +grooveData.angle) / 360) + (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 - (Math.PI / 4)) +
                                +grooveData.gap * (+grooveData.glandOpening - +grooveData.glandOpeningTol + (dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        // =(L+L tol)/2*(2*(W+W tol)+(L+L tol)/tan(θ))+(R2^2-R1^2)*(1/tan(θ/2)-pi*((180-θ)/360)+(R2^2-R1^2)*(1-pi/4)+S*(W+W Tol.+R2*(1/tan(θ/2)-1)))
        const glandAreaMaxHalf: number = (+grooveData.glandDepth + +grooveData.glandDepthTol)  / 2 * (2 * (+grooveData.glandOpening +
                                +grooveData.glandOpeningTol) + (+grooveData.glandDepth + +grooveData.glandDepthTol) /
                                this.calculateTangent(grooveData.angle)) +  (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 / this.calculateTangent(grooveData.angle / 2) -
                                Math.PI * (180 - +grooveData.angle) / 360) + (Math.pow(+grooveData.topRadius, 2) -
                                Math.pow(+grooveData.bottomRadius, 2)) * (1 - (Math.PI / 4)) +
                                +grooveData.gap * (+grooveData.glandOpening + +grooveData.glandOpeningTol + (dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)));

        if (dataToCalculate.grooveType > 1) {
          return {
            glandAreaMin: glandAreaMinHalf,
            glandAreaNom: glandAreaNomHalf,
            glandAreaMax: glandAreaMaxHalf
          };
        }
        return {
          glandAreaMin,
          glandAreaNom,
          glandAreaMax
        };
      };

      /** this section calculates volume fill minimum for cold temperature **/


      const grooveCenterLinePerimeterMax = (): number => {
        // =(Groove Diameter+Tol+W+W Tol.)*pi    For Dovetail & Halfdovetail: (Groove Diameter + Tol)*pi
        if (dataToCalculate.grooveType == 0) {
          return (+dataToCalculate.grooveData.grooveDiameter + +dataToCalculate.grooveData.grooveDiameterTol + +grooveData.glandOpening + +grooveData.glandOpeningTol) * Math.PI;
        }
        return (+dataToCalculate.grooveData.grooveDiameter + +dataToCalculate.grooveData.grooveDiameterTol) * Math.PI;
      };

      const grooveInnerPerimeterMax = (): number => {
        // =(Groove Diameter+Tol)*pi    For Dovetail & Halfdovetail: ((Groove Diameter + Tol)- (W - W Tol.) - 2*R2*(1/tan(θ/2)-1))*pi
        if (dataToCalculate.grooveType == 0) {
          return (+dataToCalculate.grooveData.grooveDiameter + +dataToCalculate.grooveData.grooveDiameterTol) * Math.PI;
        }
        return ((+dataToCalculate.grooveData.grooveDiameter + +dataToCalculate.grooveData.grooveDiameterTol) -
          (+dataToCalculate.grooveData.glandOpening - +dataToCalculate.grooveData.glandOpeningTol) -
          2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1))
          * Math.PI;
      };

      const oringAreaMin: number = Math.pow(+this.getOringDataByUnit('CS') - +this.getOringDataByUnit('CS Tolerance'), 2) * Math.PI / 4;
      const oringPerimeterMin: number = Math.PI * (+this.getOringDataByUnit('ID') - +this.getOringDataByUnit('ID Tolerance'));

      // =pi*(O-ring Size ID-ID Tol.+ O-ring Size CS - CS Tol.)
      const oringCLPerimeterMin: number = Math.PI * (+this.getOringDataByUnit('ID') - +this.getOringDataByUnit('ID Tolerance') +
          +this.getOringDataByUnit('CS') - +this.getOringDataByUnit('CS Tolerance'));

      const grooveVolumeMax: number = +grooveCenterLinePerimeterMax() * getGlandAreaByGrooveType().glandAreaMax;

      // =O-ring Area Min*O-ring CL Perimeter Min
      const oringVolumeMin: number = +oringAreaMin * +oringCLPerimeterMin;
      const coldVolumeFillMin: number = (+oringVolumeMin / +grooveVolumeMax);
      this.hiddenColdVolumeFillMin = Number(coldVolumeFillMin);

      /** this section calculates volume fill nominal for cold temperature **/

      const grooveCenterLinePerimeterNom = (): number => {
        // =(Groove Diameter+ W) *pi   For Dovetail & Halfdovetail: Groove Diameter*pi
        if (dataToCalculate.grooveType == 0) {
          return (+dataToCalculate.grooveData.grooveDiameter + +grooveData.glandOpening) * Math.PI;
        }
        return +dataToCalculate.grooveData.grooveDiameter * Math.PI;
      };
      const grooveInnerPerimeterNom = (): number => {
        // =Groove Diameter*pi   For Dovetail & Halfdovetail: (Groove Diameter- W - 2*R2*(1/tan(θ/2)-1))*pi
        if (dataToCalculate.grooveType == 0) {
          return +dataToCalculate.grooveData.grooveDiameter * Math.PI;
        }
        return (
          +dataToCalculate.grooveData.grooveDiameter -
          +dataToCalculate.grooveData.glandOpening -
          2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1)
        ) * Math.PI;
      };
      const oringAreaNom: number = Math.pow(+this.getOringDataByUnit('CS'), 2) * Math.PI / 4;
      const oringPerimeterNom: number = Math.PI * +this.getOringDataByUnit('ID');
      // =pi*(O-ring Size ID+ O-ring Size CS)
      const oringCLPerimeterNom: number = Math.PI * (+this.getOringDataByUnit('ID') + +this.getOringDataByUnit('CS'));

      const grooveVolumeNom: number = +grooveCenterLinePerimeterNom() * getGlandAreaByGrooveType().glandAreaNom;

      // =O-ring Area Nom*O-ring CL Perimeter Nom
      const oringVolumeNom: number = +oringAreaNom * +oringCLPerimeterNom;
      const coldVolumeFillNom: number = (+oringVolumeNom / +grooveVolumeNom);
      this.hiddenColdVolumeFillNom = Number(coldVolumeFillNom);

      /** this section calculates volume fill max for cold temperature **/


      const grooveCenterLinePerimeterMin = (): number => {
        // =(Groove Diameter-Tol+W-W Tol.)*pi    For Dovetail & Halfdovetail:  (Groove Diameter - Tol)*pi
        if (dataToCalculate.grooveType == 0) {
          return (+dataToCalculate.grooveData.grooveDiameter - +dataToCalculate.grooveData.grooveDiameterTol + +grooveData.glandOpening - +grooveData.glandOpeningTol) * Math.PI;
        }
        return (+dataToCalculate.grooveData.grooveDiameter - +dataToCalculate.grooveData.grooveDiameterTol) * Math.PI;
      };

      const grooveInnerPerimeterMin = (): number => {
        // =(Groove Diameter-Tol)*pi    For Dovetail & Halfdovetail: ((Groove Diameter - Tol)- (W + W Tol.) - 2*R2*(1/tan(θ/2)-1))*pi
        if (dataToCalculate.grooveType == 0) {
          return (+dataToCalculate.grooveData.grooveDiameter - +dataToCalculate.grooveData.grooveDiameterTol) * Math.PI;
        }
        return ((+dataToCalculate.grooveData.grooveDiameter - +dataToCalculate.grooveData.grooveDiameterTol) -
          (+dataToCalculate.grooveData.glandOpening + +dataToCalculate.grooveData.glandOpeningTol) -
          2 * dataToCalculate.grooveData.topRadius * (1 / this.calculateTangent(+grooveData.angle / 2) - 1))
          * Math.PI;
      };

      const oringAreaMax: number  = Math.pow(Number(this.getOringDataByUnit('CS')) +
                          Number(this.getOringDataByUnit('CS Tolerance')), 2) * Math.PI / 4;
      const oringPerimeterMax: number = Math.PI * ((Number(this.getOringDataByUnit('ID')) +
                               Number(this.getOringDataByUnit('ID Tolerance'))));
      // =pi*(O-ring Size ID+ID Tol.+ O-ring Size CS + CS Tol.)
      const oringCLPerimeterMax: number = Math.PI * ((Number(this.getOringDataByUnit('ID')) +
                               Number(this.getOringDataByUnit('ID Tolerance'))) +
                               +this.getOringDataByUnit('CS') + +this.getOringDataByUnit('CS Tolerance'));


      const grooveVolumeMin: number = +grooveCenterLinePerimeterMin() * getGlandAreaByGrooveType().glandAreaMin;

      // =O-ring Area Max*O-ring CL Perimeter Max
      const oringVolumeMax: number = +oringAreaMax * +oringCLPerimeterMax;
      const coldVolumeFillMax: number = (+oringVolumeMax / +grooveVolumeMin);
      this.hiddenColdVolumeFillMax = Number(coldVolumeFillMax);

      // =1-(L+L Tol.+S)/((O-ring Size CS-CS Tol.)*(1+CTE*(Hot Temp-Cold Temp)))
      const operatingSqueezeMin = 1 - (+grooveData.glandDepth + +grooveData.glandDepthTol + +grooveData.gap) / (
        (+this.getOringDataByUnit('CS') - +this.getOringDataByUnit('CS Tolerance')) *
        (1+ +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp))
      );
      this.hiddenColdOperatingSqueezeMin = Number(operatingSqueezeMin);
      // =1-(L+S)/((O-ring Size CS)*(1+CTE*(Hot Temp-Cold Temp)))
      const coldOperatingSqueezeNom = 1 - ((+grooveData.glandDepth + +grooveData.gap) / ((+this.getOringDataByUnit('CS')) *
        (1+ +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp))));
      this.hiddenColdOperatingSqueezeNom = Number(coldOperatingSqueezeNom);

      // =1-(L-L Tol.+S)/((O-ring Size CS+CS Tol.)*(1+CTE*(Hot Temp-Cold Temp)))
      const coldOperatingSqueezeMax = 1 - (+grooveData.glandDepth - +grooveData.glandDepthTol + +grooveData.gap) /(
        (+this.getOringDataByUnit('CS') + +this.getOringDataByUnit('CS Tolerance')) *
        (1+ +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp)));
      this.hiddenColdOperatingSqueezeMax = Number(coldOperatingSqueezeMax);

      const stretchMin: number = (grooveInnerPerimeterMin() - oringPerimeterMax) / oringPerimeterMax;
      this.hiddenStretchMin = Number(stretchMin);

      const stretchNom: number = (grooveInnerPerimeterNom() - oringPerimeterNom) / oringPerimeterNom;
      this.hiddenStretchNom = Number(stretchNom);

      const stretchMax: number = (grooveInnerPerimeterMax() - oringPerimeterMin) / oringPerimeterMin;
      this.hiddenStretchMax = Number(stretchMax);

      // =(O-ring Size CS-CS Tol. -L-L Tol.-S)/(O-ring Size CS-CS Tol.)
      const squeezeMin: number = (+this.getOringDataByUnit('CS') -
                              +this.getOringDataByUnit('CS Tolerance') -
                              +grooveData.glandDepth - +grooveData.glandDepthTol - +grooveData.gap) / (+this.getOringDataByUnit('CS') -
                              +this.getOringDataByUnit('CS Tolerance'));
      this.hiddenSqueezeMin = Number(squeezeMin);

      // =(O-ring Size CS-L-S)/(O-ring Size CS)
      const squeezeNom: number = (+this.getOringDataByUnit('CS') - +grooveData.glandDepth - +grooveData.gap) /
                                  +this.getOringDataByUnit('CS');
      this.hiddenSqueezeNom = Number(squeezeNom);

      // =(O-ring Size CS+CS Tol.-L+L Tol.-S)/(O-ring Size CS+CS Tol.)
      const squeezeMax: number = (Number(this.getOringDataByUnit('CS')) +
                        Number(this.getOringDataByUnit('CS Tolerance')) -
                        +grooveData.glandDepth + +grooveData.glandDepthTol - +grooveData.gap) / (Number(this.getOringDataByUnit('CS')) +
                        Number(this.getOringDataByUnit('CS Tolerance')));
      this.hiddenSqueezeMax = Number(squeezeMax);
      const TOringVolumeMin: number = +oringVolumeMin + 3 * +oringVolumeMin * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotVolumeFillMin: number = +TOringVolumeMin / +grooveVolumeMax;
      this.hiddenHotVolumeFillMin = Number(hotVolumeFillMin);
      const TOringVolumeNom: number = +oringVolumeNom + 3 * +oringVolumeNom * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotVolumeFillNom: number = +TOringVolumeNom / +grooveVolumeNom;
      this.hiddenHotVolumeFillNom = Number(hotVolumeFillNom);

      const TOringVolumeMax: number = +oringVolumeMax + 3 * +oringVolumeMax * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotVolumeFillMax: number = +TOringVolumeMax / +grooveVolumeMin;
      this.hiddenHotVolumeFillMax = Number(hotVolumeFillMax);

      const TOringAreaMin: number = +oringAreaMin + 2 * +oringAreaMin * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotAreFillMin: number = +TOringAreaMin / getGlandAreaByGrooveType().glandAreaMax;
      this.hiddenHotAreaFillMin = Number(hotAreFillMin);

      const TOringAreaNom: number = +oringAreaNom + 2 * +oringAreaNom * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotAreaFillNom: number = +TOringAreaNom / getGlandAreaByGrooveType().glandAreaNom;
      this.hiddenHotAreaFillNom = Number(hotAreaFillNom);

      const TOringAreaMax: number = +oringAreaMax + 2 * +oringAreaMax * +dataToCalculate.CTE * (+grooveData.operatingTemp - this.coldTemp);
      const hotAreaFillMax: number  = +TOringAreaMax / getGlandAreaByGrooveType().glandAreaMin;
      this.hiddenHotAreaFillMax = Number(hotAreaFillMax);
    }

  }


  calculateTangent(deg: number): number {
    const rad: number = deg * Math.PI / 180;
    return Math.tan(rad);
  }

  getOringDataByUnit(property: string) {
    if (!this.oringData) return;
    const currentUnit = UnitSystem.getTypeByUnit(this.dataToCalculate.units);
    return this.oringData[property + '-' + currentUnit];
  }

  validateDesign(e) {
    if (!this.parentComponent.selectedProduct) {
      this.parentComponent.openPdfClicked = true;
      window.scrollTo(0, 0);
      return;
    }
    if (!this.parentComponent.isDataFulFilled()) {
      this.formService.setTouched(this.parentComponent.oringComp.form);
      this.parentComponent.oringComp.checkForm(this.parentComponent.oringComp.form);
      this.formService.setTouched(this.parentComponent.grooveComp.form);
      this.parentComponent.grooveComp.checkForm(this.parentComponent.grooveComp.form);
      this.formService.setFocus('calcInp');
      return false;
    }
    this.calculateEventEmitter.emit('calculate');
    setTimeout( () => {
      if (this.dataToCalculate && this.dataToCalculate.oringData) {
        if (this.dataToCalculate.grooveData.operatingTemp > this.coldTemp) {
          this.volumeFillMin = (+this.hiddenHotVolumeFillMin * 100).toFixed(this.decimalCount);
          this.volumeFillNom = (+this.hiddenHotVolumeFillNom * 100).toFixed(this.decimalCount);
          this.volumeFillMax = (+this.hiddenHotVolumeFillMax * 100).toFixed(this.decimalCount);
          // remove
          // this.areaFillMin = (+this.hiddenHotAreaFillMin * 100).toFixed(this.decimalCount);
          // this.areaFillNom = (+this.hiddenHotAreaFillNom * 100).toFixed(this.decimalCount);
          // this.areaFillMax = (+this.hiddenHotAreaFillMax * 100).toFixed(this.decimalCount);
          //
        } else {
          this.volumeFillMin = (+this.hiddenColdVolumeFillMin * 100).toFixed(this.decimalCount);
          this.volumeFillNom = (+this.hiddenColdVolumeFillNom * 100).toFixed(this.decimalCount);
          this.volumeFillMax = (+this.hiddenColdVolumeFillMax * 100).toFixed(this.decimalCount);
        }
        this.operatingSqueezeMin = (+this.hiddenColdOperatingSqueezeMin * 100).toFixed(this.decimalCount);
        this.operatingSqueezeNom = (+this.hiddenColdOperatingSqueezeNom * 100).toFixed(this.decimalCount);
        this.operatingSqueezeMax = (+this.hiddenColdOperatingSqueezeMax * 100).toFixed(this.decimalCount);

        this.parentComponent.estimateGrooveSizeUnit = false;
        this.stretchMin = (+this.hiddenStretchMin * 100).toFixed(this.decimalCount);
        this.stretchNom = (+this.hiddenStretchNom * 100).toFixed(this.decimalCount);
        this.stretchMax = (+this.hiddenStretchMax * 100).toFixed(this.decimalCount);
        this.squeezeMin = (+this.hiddenSqueezeMin * 100).toFixed(this.decimalCount);
        this.squeezeNom = (+this.hiddenSqueezeNom * 100).toFixed(this.decimalCount);
        this.squeezeMax = (+this.hiddenSqueezeMax * 100).toFixed(this.decimalCount);
        this.parentComponent.calculatedData = {
          volumeFillMin: this.volumeFillMin,
          volumeFillNom: this.volumeFillNom,
          volumeFillMax: this.volumeFillMax,
          operatingSqueezeMin: this.operatingSqueezeMin,
          operatingSqueezeNom: this.operatingSqueezeNom,
          operatingSqueezeMax: this.operatingSqueezeMax,
          stretchMin: this.stretchMin,
          stretchNom: this.stretchNom,
          stretchMax: this.stretchMax,
          squeezeMin: this.squeezeMin,
          squeezeNom: this.squeezeNom,
          squeezeMax: this.squeezeMax
        };
        this.parentComponent.headerComp.calculatedData = this.parentComponent.calculatedData;
        this.parentComponent.headerComp.data = this.dataToCalculate;
      }
    }, 0);
    this.dataToSaveService.clearedData = false;
   this.trackingService.designValidated(RecommendationName[this.parentComponent.recommendationType]);
  }

  clearDesignData () {
    this.volumeFillMin = '';
    this.volumeFillNom = '';
    this.volumeFillMax = '';
    this.operatingSqueezeMin = '';
    this.operatingSqueezeNom = '';
    this.operatingSqueezeMax = '';
    this.stretchMin = '';
    this.stretchNom = '';
    this.stretchMax = '';
    this.squeezeMin = '';
    this.squeezeNom = '';
    this.squeezeMax = '';
  }


  getClassDesignCalculateElement(value: number, min, max): string {
    if (value > min && value < max) {
      return '';
    }
    return 'invalid';
  }

  initImportedData() {
    this.dataToSaveService.setCalculatedData(this.returnDataAsObject());
    const calculatedData = this.dataToSaveService.getCalculatedData();
    this.parentComponent.headerComp.calculatedData = calculatedData;
    this.parentComponent.calculatedData = calculatedData;
  }

  getSavedData(): void {
    const paths = this.dataToSaveService.getPaths();
    if (paths.length > 0 && paths[paths.length - 1] === 'saved-files') {
      setTimeout(() => {
        const activeSections = this.dataToSaveService.getActiveSections();
        const calculatedData = this.dataToSaveService.getCalculatedData();
        if (activeSections && activeSections['activateDesign'] && calculatedData) {
          this.volumeFillMin = calculatedData.volumeFillMin;
          this.volumeFillNom = calculatedData.volumeFillNom;
          this.volumeFillMax = calculatedData.volumeFillMax;
          this.operatingSqueezeMin = calculatedData.operatingSqueezeMin;
          this.operatingSqueezeNom = calculatedData.operatingSqueezeNom;
          this.operatingSqueezeMax = calculatedData.operatingSqueezeMax;
          this.stretchMin = calculatedData.stretchMin;
          this.stretchNom = calculatedData.stretchNom;
          this.stretchMax = calculatedData.stretchMax;
          this.squeezeMin = calculatedData.squeezeMin;
          this.squeezeNom = calculatedData.squeezeNom;
          this.squeezeMax = calculatedData.squeezeMax;
          this.parentComponent.calculatedData = calculatedData;
          this.parentComponent.recommendations.activateDesign = true;
        }
      });
    }
  }

  getImportedData(importedData: string[], recommendationType: string): void {
    if (importedData.length < 2) return;
    this.volumeFillMin = importedData[0];
    this.volumeFillNom = importedData[1];
    this.volumeFillMax = importedData[2];
    this.operatingSqueezeMin = importedData[3];
    this.operatingSqueezeNom = importedData[4];
    this.operatingSqueezeMax = importedData[5];
    this.stretchMin = importedData[6];
    this.stretchNom = importedData[7];
    this.stretchMax = importedData[8];
    this.squeezeMin = importedData[9];
    this.squeezeNom = importedData[10];
    this.squeezeMax = importedData[11];
    if(recommendationType === 'oring_recommendation') {
      this.parentComponent.recommendationType = 0;
    }else if(recommendationType === 'groove_recommendation') {
      this.parentComponent.recommendations.recommendationType = 1;
    }else if(recommendationType === 'design_validation') {
      this.parentComponent.recommendationType = 2;
    }
  }

  returnDataAsObject() {
    return {
      volumeFillMin: this.volumeFillMin,
      volumeFillNom: this.volumeFillNom,
      volumeFillMax: this.volumeFillMax,
      operatingSqueezeMin: this.operatingSqueezeMin,
      operatingSqueezeNom: this.operatingSqueezeNom,
      operatingSqueezeMax: this.operatingSqueezeMax,
      stretchMin: this.stretchMin,
      stretchNom: this.stretchNom,
      stretchMax: this.stretchMax,
      squeezeMin: this.squeezeMin,
      squeezeNom: this.squeezeNom,
      squeezeMax: this.squeezeMax
    };
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/design-validation/design-validation.component.ts